<div class="record-address-content" *ngFor="let field of headerFields">
  <p>
    <ng-container
      *ngIf="templateProjectionMap != null && field.options.hasAnchor; else addressField"
      [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-goes-to-record'"
      [ngTemplateOutletContext]="{
        classes: 'record-link',
        urlParams: reportRecordData | reportFieldRouteFn: { templateId: currentView.templateId, field: field },
        content: addressField,
      }"
    >
    </ng-container>
    <ng-template #addressField>
      <span>
        {{
          reportRecordData
            | reportFieldFormatter
              : { templateId: currentView?.templateId, field: field, joinString: true, onlyUrl: false }
            | async
        }}
      </span>
    </ng-template>
  </p>
</div>
